import { useTranslation } from 'react-i18next'
import { MAX_CHARS } from 'src/components/communitySurvey/createCommunitySurvey/steps/communityCreationChallenges/communityCreationChallenges.constants'
import { useSecondPostSurvey } from 'src/components/communitySurvey/hooks/useSecondPostSurvey'
import useHandleChangeTextArea from 'src/components/customTextArea/hooks/handleChangeTextArea/handleChangeTextArea'
import CustomTextArea from 'src/components/customTextArea/customTextArea'
import { faArrowRight } from '@fortawesome/pro-light-svg-icons/faArrowRight'
import { faArrowLeft } from '@fortawesome/pro-light-svg-icons/faArrowLeft'
import Button from '@hotmart/space-lib/dist/components/button'
import Icon from '@hotmart/space-lib/dist/components/icon'
import {
  PROGRESS_BAR_VALUE_SECOND_POST_IMPROVEMENT_FROM_MOST_LIKED_STEP,
  PROGRESS_BAR_VALUE_SECOND_POST_MOST_LIKED_STEP,
  Step
} from '../../secondPostSurvey.constants'
import { ContainerButtons } from './secondPostMostLiked.styles'

const SecondPostMostLiked = ({ navigateToNextStep, setProgressBarValue }) => {
  const { t } = useTranslation()
  const {
    secondPostMostLikedText,
    setSecondPostMostLikedText,
    setLastProgressBarValue,
    lastStep,
    lastProgressBarValue,
    setLastStep
  } = useSecondPostSurvey()
  const handleChange = useHandleChangeTextArea(setSecondPostMostLikedText, MAX_CHARS)

  const nextClick = () => {
    navigateToNextStep(Step.SecondPostImprovement)
    setLastStep(Step.SecondPostMostLiked)
    setLastProgressBarValue(PROGRESS_BAR_VALUE_SECOND_POST_MOST_LIKED_STEP)
    setProgressBarValue(PROGRESS_BAR_VALUE_SECOND_POST_IMPROVEMENT_FROM_MOST_LIKED_STEP)
  }

  const stepback = () => {
    setProgressBarValue(lastProgressBarValue)
    navigateToNextStep(lastStep)
  }

  return (
    <>
      <h1 className="_text-3 _font-weight-light _text-gray-700 _mb-6">
        {t('community_survey.second_post.most_liked.title')}
      </h1>

      <CustomTextArea
        value={secondPostMostLikedText}
        maxSize={MAX_CHARS}
        currentSize={secondPostMostLikedText.length}
        name={t('community_survey.second_post.most_liked.title')}
        placeholder={`${t('community_survey.create_community.challenges.placeholder')}...`}
        onChange={handleChange}
      />

      <ContainerButtons className="_d-flex _justify-content-end _align-items-center">
        <Button variation="tertiary" onClick={stepback}>
          <Icon className="_mr-2" icon={faArrowLeft} />
          {t('modals.schedule_posts.buttons.back')}
        </Button>

        <Button
          disabled={secondPostMostLikedText.length === 0}
          className="_ml-3"
          variation="primary"
          onClick={nextClick}
        >
          {t('community_survey.buttons.next_step')}
          <Icon className="_ml-2" icon={faArrowRight} />
        </Button>
      </ContainerButtons>
    </>
  )
}

export default SecondPostMostLiked
